import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BitwerxOfferingInfo = ({ label, icon, children }) => (
    <div className="mb-4">
        <h4 className="op-7">
            {icon && (
                <>
                    <FontAwesomeIcon icon={icon} />
                    &emsp;
                </>
            )}
            {label}
        </h4>
        {children}
    </div>
);

export default BitwerxOfferingInfo;
